#import "~/graphql/fragments/Components/MenuOverlay.graphql"
#import "~/graphql/fragments/Globals/ContactInformation.graphql"

query MainNavigation($site: [String!]) {
    entry(site: $site, section: "navigation") {
        ...NavigationMenuLinks
    }
    generalInformationEntries {
        ...GlobalContactInformation
    }
}
